import Vue from 'vue';
import Router from 'vue-router';
import { weChatShare } from '$wechat';
import { useInVueRouter , scrollBehavior } from '$use-in-vue-router';
import RouterID from '$use-in-vue-router/router-id';
import RouterMeta from '$use-in-vue-router/router-meta';
import { routerBeforeEach } from "$use-in-vue-router/router-before";
import { routerAfterEach } from "$use-in-vue-router/router-after";
import { useInVueRouterProgram } from '../use-in-vue-router-program';

//路由地址
import routes from './routes';

Vue.use(Router);

//router相关的插件
useInVueRouter(Router);

//路由标记
//export const routerID = new RouterID();
export const routerMeta = new RouterMeta();

const router = new Router({
  namespace: true,
//  routes: routerID.addID(routes)
  routes: routerMeta.setMeta(routes),
  scrollBehavior
});


const sess = window.sessionStorage;

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

//Vue.mixin({
//  beforeRouteLeave(to,from,next){
////    console.log(to);
//    let toRoute = to.path ;
////    let fromRoute = from.path ;
//    let h = JSON.parse(sess.getItem(toRoute));
//    if(h && h.history){
//      this.$destroy();
//      next()
//    }else{
//      next()
//    }
//    next()
//  }
//})


//项目扩展router
useInVueRouterProgram({
  Router,
//  routerID
});

//router before each
routerBeforeEach({
  router,
  beforeEach(to, from) {
//    let toRoute = to.path ;
//    let fromRoute = from.path ;
////    console.log(fromRoute,toRoute)
//    let h = JSON.parse(sess.getItem(toRoute));
//    if(h && h.history){
//      h.history = false ;
//      sess.removeItem(toRoute)
//    }else{
//      sess.setItem(fromRoute || '/' , JSON.stringify({ history:true }))
//    }

    //四种情况，path，false，Error参照官方文档中的next处理 true 或者 undefined 走默认的next()处理
    //处理多层级的的next状态查看一下RouterNext的处理
    return true;
  }
});

//router after each
routerAfterEach({
  router,
  //根据项目需要的after each（可选）
  afterEach(to, from) {

  },
  unAfterHook() {
    weChatShare();
  }
});

export default router;
